import { Component, OnInit } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { CheckDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-pos-order-entry",
	templateUrl: "./pos-order-entry.component.html",
	styleUrls: ["./../pos.scss"],
})
export class PosOrderEntryComponent implements OnInit {
	viewMobileCheck: boolean = false;
	viewCheckList: boolean;

	constructor(public posService: PosService) {}

	ngOnInit(): void {
		if (this.posService.checkList.value.length > 0) {
			this.viewCheckList = true;
		}
		this.posService.orderService.activeOrder.subscribe((data) => {
			if (!data.checkKey) {
				this.viewCheckList = true;
			}
		});
	}

	onMobileViewCheck() {
		this.viewMobileCheck = true;
	}

	onCheckChange() {
		console.log("fired");
		this.posService.orderService.activeOrder.next(new CheckDto());
		this.viewCheckList = true;
	}
}
